import { useNavigate } from 'react-router-dom';
import './BikePriceCard.css';

const fmt = (n) =>
  '₹' + (
    n >= 100000
      ? (n / 100000).toFixed(2).replace(/\.?0+$/, '') + 'L'
      : Math.round(n / 1000) + 'K'
  );

export default function BikePriceCard({
  bike,
  onCompare,
  isComparing,
}) {

  const navigate = useNavigate();

  return (
    <article className="bike-card">

      {/* IMAGE */}
      <div className="bike-card-media">

        <img
          src={bike.image}
          alt={bike.name}
          className="bike-card-image"
        />

        <span className="bike-card-category">
          {bike.type}
        </span>

      </div>

      {/* BODY */}
      <div className="bike-card-body">

        <h3 className="bike-card-title">
          {bike.name}
        </h3>

        <p className="bike-card-desc">
          Compare on-road price, mileage,
          EMI and engine specifications.
        </p>

        {/* SPECS */}
        <div className="bike-card-specs">

          <div className="bike-card-spec">
            <span>Ex-showroom</span>
            <strong>{fmt(bike.price)}</strong>
          </div>

          <div className="bike-card-spec">
            <span>On-road</span>
            <strong>{fmt(bike.onRoad)}</strong>
          </div>

          <div className="bike-card-spec">
            <span>Mileage</span>
            <strong>{bike.mileage} kmpl</strong>
          </div>

          <div className="bike-card-spec">
            <span>Engine</span>
            <strong>{bike.cc}cc</strong>
          </div>

        </div>

        {/* ACTIONS */}
        <div className="bike-card-actions">

          <button
            onClick={() => navigate('/calculator')}
            className="bike-btn-primary"
          >
            💰 EMI
          </button>

          <button
            onClick={() => onCompare && onCompare(bike.id)}
            className={`bike-btn-secondary ${
              isComparing ? 'bike-btn-active' : ''
            }`}
          >
            {isComparing ? '✓ Added' : '⚖️ Compare'}
          </button>

        </div>

      </div>

    </article>
  );
}